import { render, staticRenderFns } from "./LegacyFunnelChartWidget.vue?vue&type=template&id=dddf2a7a&"
import script from "./LegacyFunnelChartWidget.vue?vue&type=script&lang=js&"
export * from "./LegacyFunnelChartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports